module.exports = __webpack_public_path__ + "img/handeye.a6532e9a.svg";